module.exports = __webpack_public_path__ + "static/media/image_1.62fb99f5.png";